import { AppTreeSide, UniDateRangePicker } from 'components'
import SelectFileModal from './selectFileModal'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree} from '@/utils/tree'
// import {getTodayBeginAndEndDate, getOneWeekBeginAndEndDate} from '@/utils/date'

export default {
  name: 'BroadcastSystem',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 底部栏打开标志
      footerOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 节点列表页面--------------------------------------------------------------------------------------------------
      // 卡片数据
      cardData: [], //
      cardTotalItem: 0, // 记录总数
      cardMaxRowCount: 3, // 当前页卡片最大行数
      cardMaxColCount: 6, // 当前页卡片最大列数
      cardRowCount: 0, // 当前页卡片实际行数
      cardColCountPerRows: [], // 当前页卡片每行列数
      // 卡片查询条件
      cardQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 26,
        gaugedObjectKind: 255,
        alarmStates: [],
        // systemKind: this.systemKind,
        encoderStateRequired: 1, // 要求返回监控设备状态
        pageNum: 1,
        pageSize: 8
      },
      pageTotalCount: 0,
      pageNormalCount: 0,
      pageAlarmCount: 0,
      pageErrorCount: 0,
      // 卡片当前项
      cardCurrentItem: null,
      // 卡片选中项状态数组（选中为true，否则为false）
      cardSelectedStates: [],
      // 语音节点信息弹窗
      showVoiceNodeModalOpen: false,
      // 控制栏
      activeControlBarTabName: '0',
      voiceOpenMode: 1, // 打开模式，1-对讲，2-广播，3-监听，4-文件播放
      allCardSelected: false,
      // 选择文件弹窗
      selectedFileModalOpen: false,
      // voip控制参数
      controlParams: {
        action: 0, // 动作，0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
        fromNodeId: 0, // 主控终端id，0-自动
        fromFileCount: 0,
        fromFileIndexList: [], // 选中文件索引数组
        fromFileNameList: [], // 选中文件名称数组
        fromfilePlayMode: 0, // 文件播放模式，0-单次播放，1-循环播放
        fromFilePlayTimes: 0, // 文件播放次数，0-不限
        toNodeCount: 0,
        toNodeIdList: [],
        volume: 255
      },
      // 轮巡定时器
      pollingTimer: null
    }
  },
  props: {
    systemKind: {
      type: Number,
      default() {
        return 2300 // 广播系统
      }
    }
  },
  components: {
    SelectFileModal,
    AppTreeSide,
    UniDateRangePicker
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }
  },
  mounted () {
    // 根据浏览器高度设置卡片最大行数
    this.cardMaxRowCount = window.innerHeight < 800 ? 2 : 3
    this.cardMaxColCount = window.innerHeight < 800 ? 4 : 6
    // 根据卡片最大行数和最大列数返回页数
    this.cardQueryParams.pageSize = this.cardMaxRowCount * this.cardMaxColCount

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()

      // 开始数据轮巡
      this.startDataPolling()
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()

    // 停止定期检测尺寸大小改变
    if (this.reizeTimer != null) {
      clearInterval(this.reizeTimer)
      this.reizeTimer = null
    }
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    toggleFooter() {
      this.footerOpen = !this.footerOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点或根节点的首个子节点为当前节点
            let currentKey = null
            if (this.$globalConfig.currentRegionSynchEnabled && this.$store.getters.appCurrentRegionKey) { // 当前区域同步启用
              currentKey = this.$store.getters.appCurrentRegionKey
            } else {
              if (this.$globalConfig.defaultCurrentTreeNode === 0) { // 根节点
                currentKey = this.treeData[0].key
              } else if (this.$globalConfig.defaultCurrentTreeNode === 1) { // 根节点的首个子节点
                currentKey = this.treeData[0].children.length > 0 ? this.treeData[0].children[0].key : this.treeData[0].key
              }
            }
            if (currentKey) {
              this.$refs.tree.setCurrentKey(currentKey)
              // 单击当前节点
              this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
            }
            // 只有一个树节点自动隐藏侧边栏
            if (this.treeData[0].children.length === 0) {
              this.treeSideBarOpen = false
            }
          }
        })
      })
    },
    // 查询语音节点列表
    getVoiceNodeList() {
      this.loading = true
      this.$http(this.$api.voiceNodeList, this.cardQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              item.state = 0 // 语音状态，0-空闲中，1-通话中
              item.pictureUrl = '/static/img/voice/hang.png'
            })

            this.cardData = res.data
            this.cardTotalItem = res.page.totalRow
            // 计算卡片行数
            this.cardRowCount = Math.ceil(this.cardData.length / this.cardMaxColCount) // 向上取整
            // 计算卡片每行列数
            this.cardColCountPerRows = []
            for (let i = 0; i < this.cardRowCount; ++i) {
              this.cardColCountPerRows[i] = (this.cardData.length - this.cardMaxColCount * i) / this.cardMaxColCount >= 1 ? this.cardMaxColCount : (this.cardData.length - this.cardMaxColCount * i) % this.cardMaxColCount
              this.cardColCountPerRows[i] = Math.abs(this.cardColCountPerRows[i]) // 余数可能为负，需取绝对值
            }

            if (res.data.length) {
              if (this.cardCurrentItem === null) {
                this.cardCurrentItem = res.data[0] // 选中首项
              } else {
                this.cardCurrentItem = this.getRecordById(this.cardCurrentItem.id, res.data)
                if (this.cardCurrentItem === null) { // 数组是否包含选中项
                  this.cardCurrentItem = res.data[0] // 选中首项
                }
              }
            }
            // 统计当前页面节点数量
            this.statPageVoiceNodeCount()
          }
          this.loading = false
        }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 统计当前页面节点数量
    statPageVoiceNodeCount() {
      this.pageTotalCount = 0
      this.pageNormalCount = 0
      this.pageAlarmCount = 0
      this.pageErrorCount = 0
      if (this.cardTotalItem === 0) {
        return
      }

      this.cardData.forEach(item => {
        ++this.pageTotalCount
        if (item.alarmState === 0) {
          ++this.pageNormalCount
        } else if (item.alarmState === 1) {
          if (item.eventTypeSet === 0x02) {
            ++this.pageErrorCount
          } else {
            ++this.pageAlarmCount
          }
        }
      })
    },
    // Voip控制
    voipControl() {
      if (this.cardCurrentItem == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      // 打开模式，1-对讲，2-广播，3-监听，4-文件播放
      if (this.voiceOpenMode === 1) { // 双向对讲
        this.controlParams.toNodeCount = 1
        this.controlParams.toNodeIdList = []
        this.controlParams.toNodeIdList = [this.cardCurrentItem.id]
      } else if (this.voiceOpenMode === 2 || this.voiceOpenMode === 4) { // 采集广播或文件广播
      }

      this.$http(this.$api.voipControl, this.controlParams).then(
        res => {
          if (res.code === 200) {
            // 打开模式，1-对讲，2-广播，3-监听，4-文件播放
            if (this.voiceOpenMode === 1) { // 双向对讲
              // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
              if (this.controlParams.action === 0 || this.controlParams.action === 1 || this.controlParams.action === 3) {
                this.cardCurrentItem.state = 1
                this.cardCurrentItem.pictureUrl = '/static/img/voice/call.png'
              } else if (this.controlParams.action === 2 || this.controlParams.action === 4) {
                this.cardCurrentItem.state = 0
                this.cardCurrentItem.pictureUrl = '/static/img/voice/hang.png'
              }
            } else if (this.voiceOpenMode === 2 || this.voiceOpenMode === 4) { // 采集广播或文件广播
              this.cardData.forEach((item, index) => {
                if (this.cardSelectedStates[index]) { // 卡片选中状态
                  // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
                  if (this.controlParams.action === 5 || this.controlParams.action === 10) {
                    item.state = 1
                    item.pictureUrl = '/static/img/voice/call.png'
                  } else if (this.controlParams.action === 6 || this.controlParams.action === 11) {
                    item.state = 0
                    item.pictureUrl = '/static/img/voice/hang.png'
                  }
                }
              })
            }
            // this.$message({
            //   type: 'success',
            //   message: '操作成功!'
            // })
          }
        }
      )
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.activeTabName === '0') {
          // if (this.showVoiceNodeModalOpen) { // 暂停刷新数据
          //   return
          // }
          // this.getRealEventList()
        } else if (this.activeTabName === '1') {
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.activeTabName === '0') {
        if (this.cardQueryParams.regionId !== obj.id) {
          this.cardQueryParams.regionId = obj.id
          this.cardQueryParams.pageNum = 1
          this.getVoiceNodeList()
        }
      } else if (this.activeTabName === '1') {
        if (this.historyEventTableQueryParams.regionId !== obj.id) {
          this.historyEventTableQueryParams.regionId = obj.id
          this.historyEventTableQueryParams.pageNum = 1
        }
      }

      if (this.$globalConfig.currentRegionSynchEnabled) { // 当前区域同步启用
        this.$store.commit('app/SET_CURRENT_REGION_KEY', obj.key) // 更新当前区域key
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      let currentNode = this.$refs.tree.getCurrentNode()
      if (currentNode) {
        this.handleTreeNodeClick(currentNode)
      }
    },
    // 节点列表页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleFormQuery() {
      this.cardQueryParams.page = 1
      this.getVoiceNodeList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.cardQueryParams.regionId = 0
      this.cardQueryParams.nodeId = 0
      this.cardQueryParams.descendantRegionRequired = 1
      this.cardQueryParams.resourceKind = 26
      this.cardQueryParams.gaugedObjectKind = 255
      this.cardQueryParams.alarmStates = []
      this.cardQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.cardQueryParams.pageNum = val
      this.getVoiceNodeList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.cardQueryParams.pageSize = val
      this.getVoiceNodeList()
    },
    // 查看语音节点信息
    handleVoiceNodeView(item) {
      if (item) {
        this.cardCurrentItem = item // 选中当前项
        this.showVoiceNodeModalOpen = true
      }
    },
    // 语音节点信息取消提交
    handleShowVoiceNodeModalCancel() {
      this.showVoiceNodeModalOpen = false
    },
    // 节点控制栏tab页面切换
    handleControlBarTabClick(tab) {
      if (this.activeControlBarTabName === '0') { // 双向对讲
        this.voiceOpenMode = 1 // 打开模式，1-对讲，2-广播，3-监听，4-文件播放
      } else if (this.activeControlBarTabName === '1') { // 采集广播
        this.voiceOpenMode = 2 // 打开模式，1-对讲，2-广播，3-监听，4-文件播放
      } else if (this.activeControlBarTabName === '2') { // 文件广播
        this.voiceOpenMode = 4 // 打开模式，1-对讲，2-广播，3-监听，4-文件播放
      }
    },
    // 处理卡片全选（注意：修改数组中元素值无法改变界面状态，必须修改数组本身）
    handleAllCardSelectedChange(val) {
      this.cardSelectedStates = []
      for (let i = 0; i < this.cardMaxRowCount * this.cardMaxColCount; ++i) {
        this.cardSelectedStates.push(val)
      }
    },
    // 处理呼叫
    handleCall() {
      this.controlParams.action = 0 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      this.voipControl()
    },
    // 处理接听
    handleAnswer() {
      this.controlParams.action = 1 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      this.voipControl()
    },
    // 处理挂断
    handleHang() {
      this.controlParams.action = 2 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      this.voipControl()
    },
    // 处理开始采集广播
    handleStartBroadcast() {
      this.controlParams.action = 5 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      // 汇总目标终端
      this.controlParams.toNodeCount = 0
      this.controlParams.toNodeIdList = []
      this.cardData.forEach((item, index) => {
        if (this.cardSelectedStates[index]) { // 卡片选中状态
          this.controlParams.toNodeIdList.push(this.cardData[index].id)
          ++this.controlParams.toNodeCount
        }
      })

      if (this.controlParams.toNodeCount <= 0) {
        this.$messagebox.confirm('请至少选中一个目标终端！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      this.voipControl()
    },
    // 处理停止采集广播
    handleStopBroadcast() {
      this.controlParams.action = 6 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      this.voipControl()
    },
    // 处理选择文件弹窗
    handleSelectFile() {
      this.selectedFileModalOpen = true
    },
    // 处理开始文件播放
    handleStartFilePlay() {
      this.controlParams.action = 10 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      if (this.controlParams.fromFileCount <= 0) {
        this.$messagebox.confirm('请至少选择一个文件！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      // 汇总目标终端
      this.controlParams.toNodeCount = 0
      this.controlParams.toNodeIdList = []
      this.cardData.forEach((item, index) => {
        if (this.cardSelectedStates[index]) { // 卡片选中状态
          this.controlParams.toNodeIdList.push(this.cardData[index].id)
          ++this.controlParams.toNodeCount
        }
      })

      if (this.controlParams.toNodeCount <= 0) {
        this.$messagebox.confirm('请至少选中一个目标终端！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      this.voipControl()
    },
    // 处理停止文件播放
    handleStopFilePlay() {
      this.controlParams.action = 11 // 0-呼叫，1-接听，2-挂断，3-开始侦听，4-停止侦听，5-开始广播，6-停止广播，10-开始文件播放，11-停止文件播放，20-设置音量
      this.voipControl()
    },
    //  选择文件弹窗提交
    handleSelectFileModalSubmit(fileIndexs, fileNames) {
      if (fileIndexs) {
        this.controlParams.fromFileCount = fileIndexs.length
        this.controlParams.fromFileIndexList = fileIndexs
        this.controlParams.fromFileNameList = fileNames
      } else {
        this.controlParams.fromFileCount = 0
        this.controlParams.fromFileIndexList = []
        this.controlParams.fromFileNameList = []
      }
      this.selectedFileModalOpen = false
    },
    // 选择文件弹窗取消提交
    handleSelectFileModalCancel() {
      this.selectedFileModalOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/BroadcastSystem/BroadcastSystem.js